import Service from "../../AuthService";

const BillingPayment = {
    getBillingPayment(page){
        return Service.get("/billing-payment?page="+page);
    },
    createBillingPayment(data) {
        return Service.post("/billing-payment", data)
    },
    getBillingPaymentById(id){
        return Service.get("/billing-payment/"+id)
    },
    updateBillingPayment(id, data) {
        return Service.put("/billing-payment/" + id, data)
    },
    deleteBillingPayment(id) {
        return Service.delete("/billing-payment/" + id)
    },
}

export default BillingPayment
